import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const EMPTY = { game: [], creator: [], template: [], asset: [], world: [] };
const Ctx = createContext(null);

export function FavoritesProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState(EMPTY);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/favorites/ids");
      setIds({ ...EMPTY, ...data });
    } catch { /* ignore */ }
  }, []);

  useEffect(() => { if (user) load(); else setIds(EMPTY); }, [user, load]);

  const isFav = useCallback((type, id) => (ids[type] || []).includes(id), [ids]);

  const toggle = useCallback(async (type, id, collectionId) => {
    setIds((prev) => {
      const arr = prev[type] || [];
      const has = arr.includes(id);
      return { ...prev, [type]: has ? arr.filter((x) => x !== id) : [...arr, id] };
    });
    try {
      const { data } = await api.post("/favorites/toggle", { item_type: type, item_id: id, collection_id: collectionId || null });
      if (data.favorited) toast.success("Added to favourites ⭐");
      else toast("Removed from favourites");
      return data.favorited;
    } catch {
      load();
      toast.error("Couldn't update favourites");
    }
  }, [load]);

  return <Ctx.Provider value={{ ids, isFav, toggle, reloadFavorites: load }}>{children}</Ctx.Provider>;
}

export const useFavorites = () => useContext(Ctx) || { ids: EMPTY, isFav: () => false, toggle: () => {}, reloadFavorites: () => {} };
